import { Button, IconButton, Menu } from '@material-ui/core'
import { Close } from '@material-ui/icons'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { SIDE_NAV_CLOSE } from '../../../constants/navigationConstants'
import { PROJECT_EXIT_REQUEST } from '../../../constants/projectConstants'
import { useDateFormatter } from '../../../hooks/useDateFormatter'
import { ReactComponent as ChatIcon } from '../../../assets/img/icons/comments.svg'
import { useState } from 'react'
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown'
import ProjectStatusBar from './ProjectStatusBar'
import ProjectHeaderStatusItem from './ProjectHeaderStatusItem'
import ArchiveModal from './ArchiveModal'

export const ProjectStatus = {
  NEW: 'New',
  SUBMITTED_FOR_REVIEW: 'Submitted for review',
  QUOTE_SUBMITTED: 'Quote submitted',
  IN_PROGRESS: 'In progress',
  PENDING_ACCEPTANCE: 'Pending acceptance',
  COMPLETE: 'Complete',
  ARCHIVED: 'Archived',
}

const ProjectHeader = ({ setShowActivityPanel }) => {
  const dispatch = useDispatch()
  const history = useHistory()

  const [menu, setMenu] = useState(undefined)
  const [showArchiveModal, setShowArchiveModal] = useState(false)

  const { project } = useSelector((state) => state.projectDetails)
  const { userInfo } = useSelector((state) => state.userLogin)

  const lastUpdated = useDateFormatter(project ? project.updatedAt : '')

  const handleSaveAndExit = () => {
    if (userInfo.isAdmin) {
      dispatch({ type: PROJECT_EXIT_REQUEST })
    } else {
      dispatch({ type: SIDE_NAV_CLOSE })
      history.push('/myquality/dashboard')
    }
  }

  const handleMenuClick = (e) => {
    setMenu(e.currentTarget)
  }

  const handleMenuClose = () => {
    setMenu(undefined)
  }

  return (
    <div className="flex space-between p-t-16 p-b-16 m-b-32 bottom-border-gradient">
      <div className="hide-580">
        <Button variant="contained" color="primary" onClick={handleSaveAndExit}>
          Save and exit
        </Button>
      </div>
      <div className="flex align-center flex-grow flex-end hide-580">
        <div className="strong m-r-8">
          {userInfo.isAdmin ? (
            <Button
              aria-controls="menu"
              aria-haspopup="true"
              onClick={handleMenuClick}
              className="p-r-4 p-l-8"
            >
              <span className="fs16">{project.status}</span>

              <ArrowDropDownIcon
                style={{ color: 'black', fontSize: 16 }}
                className="p-r-0 m-l-4"
              />
            </Button>
          ) : (
            <div className="fs16 m-r-16">{project.status}</div>
          )}

          <Menu
            id="vpf-menu"
            anchorEl={menu}
            open={!!menu}
            onClose={handleMenuClose}
            className="menu"
            PaperProps={{
              style: {
                left: '0%',
                transform: 'translateX(calc(0 + 24px)) translateY(148px)',
              },
            }}
          >
            {Object.keys(ProjectStatus).map((keyName, index) => (
              <ProjectHeaderStatusItem
                key={index}
                close={handleMenuClose}
                status={ProjectStatus[keyName]}
                setShowArchiveModal={setShowArchiveModal}
              />
            ))}
          </Menu>
        </div>

        <ProjectStatusBar />

        <div className="m-r-24 fs14 hide-1100">
          Last updated <span className="gray-text m-l-5">{lastUpdated}</span>
        </div>

        <Button
          variant="outlined"
          className="m-r-16"
          onClick={() => setShowActivityPanel(true)}
        >
          <ChatIcon className="m-r-5" style={{ width: 20 }} /> Open activity
        </Button>
        <IconButton onClick={() => history.push('/myquality/dashboard')}>
          <Close />
        </IconButton>
      </div>

      <div
        className="show-580 flex space-between align-center"
        style={{ width: '100%' }}
      >
        <div className="strong m-r-16" style={{ fontSize: 14 }}>
          {project.status}
        </div>
        <div>
          <IconButton onClick={() => setShowActivityPanel(true)}>
            <ChatIcon />
          </IconButton>
          <IconButton onClick={() => history.push('/myquality/dashboard')}>
            <Close />
          </IconButton>
        </div>
      </div>

      <ArchiveModal
        showArchiveModal={showArchiveModal}
        setShowArchiveModal={setShowArchiveModal}
      />
    </div>
  )
}

export default ProjectHeader
